import React from 'react';
import { NavLink } from 'react-router-dom';

import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { isNotNull } from '@totem/utilities/common';

export const createMenuLabel = (
  item: IBMenuItem,
  display: React.ReactNode,
): React.ReactNode => {
  if (isNotNull(item.route)) {
    return <NavLink to={item.route}>{display}</NavLink>;
  }

  return display;
};
